import React from "react";

export default function FaqStudent() {
    return (
        <div className="">
            <h1 className="md:text-5xl text-3xl font-semibold text-center my-8">
                <span className="text-blue-500">FAQs</span> of <span className="text-orange-400">students</span>
            </h1>
            <Student
                question='How long can I talk with the counsellor?'
                answer="The typical booking window lasts for 30 minutes. As long as there are still open spots, you may reserve any number of them. Depending on the counsellor’s availability and the user's request, an extension to any call may be permitted."
            />
            <Student
                question='What is the charge to book a call with a Counsellor?'
                answer="There is no extra charge for booking a call with the counsellor, it is covered under the ABHAY program offered by the career hikers."
            />
            <Student
                question='What is an ABHAY program?'
                answer="All of the students in the ABHAY programme receive individualised counselling in pursuit of their objective of choosing the finest professional path. We thus have a pool of more than 100 counsellors, and these counsellors lay out the road map for all students by giving them individualised direction, care, confidence, encouragement, and positive reinforcement, among other things. Basically, we encourage and give the proper advice for their route through our mentoring programme. We're not here to impart knowledge; rather, we're here to advise pupils on how to forge on with their lives."
            />
            <Student
                question='How do I have to pay for joining the ABHAY program?'
                answer="From our secure payment gateway, you may make payments using a variety of methods, including debit/credit cards, net banking, and UPI (Powered by Cashfree)."
            />
            <Student
                question='What if my call gets disconnected in between?'
                answer="In such a case, our team will connect your call again with the counsellor immediately and you can continue your interaction."
            />
            <Student
                question='What if I want to talk to the same counsellor second time?'
                answer="If you want to call the same counsellor again, you can reach out to our team on help@careerhikers.com for the same"
            />
            <Student
                question='Can my initial details be changed after my account is set up?'
                answer="In such cases where you need to change your details like Phone number, email, name, etc. you may write to us at info@careerhikers.com and our team will be happy to assist you further."
            />
            <Student
                question="What type of questions can I ask to the counsellor?"
                answer="You can inquire about anything pertaining to your preparation, including queries concerning your motivation, college life, board examinations, and books and other reference materials. Please refrain from requesting personal contact information from any of the counsellors because doing so might result in suspension from the site. Please be polite and refrain from using bad language while speaking with the counsellor."
            />
            <Student
                question="What if I am not satisfied after conversation with counsellor?"
                answer="Our first concern at Career Hikers is to make sure that the interaction enables you to get greater understanding about preparation as well as assist you in identifying strategies to enhance your performance on the test or in relation to future objectives. If the call experience was not satisfactory to you, send us your comments at feedback@careerhikers.com, and a member of our staff will get in touch with you to address your problems right away."
            />
            <Student
                question="What if I don't receive the call?"
                answer="This might occur as a result of phone network faults or any other unanticipated complications. In these situations, a member of our staff will let you know about the delay and reschedule your call for a time of your choosing. Please email us at info@careerhikers.com if you do not hear from us within 24 hours of your scheduled time slot; we will address the situation as quickly as possible."
            />
            <Student
                question="Can I call the expert/counsellor directly?"
                answer="Users are strongly discouraged from getting in touch with the toppers directly. The user may be prevented from utilising Career Hikers's services in the future if they violate any rules."
            />
            <Student
                question="Can I talk to the experts on video call?"
                answer="Currently, only phone-based audio calls are eligible for slot booking. As soon as the services from various forms of contact (such as video, chat, etc.) are live, we'll keep you informed about their availability."
            />
            <Student
                question="Do we offering counselling only to the paid students?"
                answer="No, we are not offering this counselling service only to the paid students. Our career counselling service is completely free to all students, students have to pay if they want more specification, personal guidance, live support which are covered under ABHAY program. But in the case, if any students are unable to pay their fees and still want to continue in our platform so still, we offer our mentorship program to our students. They can connect to us on help@careerhikers.com."
            />
        </div>

    )
}

function Student(props) {
    return (
        <div className="collapse border-2 mx-4 md:mx-16">
            <input type="checkbox" />
            <div className="collapse-title text-lg md:text-xl font-medium">
                {props.question}
            </div>
            <div className="collapse-content md:text-base text-sm">
                <p>{props.answer}</p>
            </div>
        </div>
    )
}